export const extractEmployeeId = (token: string | undefined): string | undefined =>
  token ? token.split(':')[0] : undefined;
